import React, {useState, useRef, useEffect} from 'react';
import { connect } from 'react-redux';
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';
import { 
    Flex, Box, Heading, FormControl, FormLabel, Input, Button, ButtonGroup, Text, CircularProgress, CircularProgressLabel,
    InputGroup, InputRightElement, InputRightAddon, Icon, IconButton,
    Stack, HStack, Image, Wrap, WrapItem, Center, Select, Checkbox,
    Grid, GridItem, VStack, Spacer, Divider, Badge, Drawer, DrawerBody, DrawerContent, DrawerCloseButton, DrawerHeader, DrawerOverlay,
    Table, Thead, Tbody, Tfoot, Tr, Th, Td, TableCaption, TableContainer, Collapse,
    useDisclosure
} from '@chakra-ui/react';
import { MdThumbUp, MdNoteAlt, MdHistory, MdCancel, MdPending } from 'react-icons/md';
import { withNamespaces } from 'react-i18next';
import { setNavTab } from '../../redux/actions';
import { getCurrentNavTab } from '../../redux/selectors';
import { ACTIVE_VIEW_SCHEDULE_TAB } from '../../redux/constants';
import { 
    WORK_HOURLY_LIST, MEDICAL_WAITING_STATUS, MEDICAL_WAITING_STATUS_EN, ALL, 
    PROCESSING_STATUS, PENDING_STATUS, CANCEL_STATUS, FINISHED_STATUS, SUCCESS_STATUS, FAILED_STATUS
} from '../../constants';

import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.module.css';

import { isNil, orderBy } from 'lodash';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/ReactToastify.css';

import { FormattedDate, FormattedTime } from 'react-intl';

import { apiLoadASystemSettingByCompanyId } from '../../redux/apis/SystemSettingApis';
import { apiLoadListScheduleMedical, apiUpdateAScheduleMedical } from '../../redux/apis/ScheduleMedicalApis';
import { clearScheduleMedicalActionStatus } from '../../redux/actions';
import { getASystemSetting, getScheduleMedicalList, getScheduleMedicalActionStatus, getScheduleMedicalActionMsg } from '../../redux/selectors';
import { displayConfirmAlert, displayConfirmChoiceAlert } from '../utils';
import i18n from '../../i18n';

import Header from './Header';
import Navbar from './Navbar';
import NoDataPage from '../../components/NoData';
import NoEventPage from '../../components/NoEvent';
import AddEditPatientResultModal from './Modals/AddEditPatientResultModal';
import PatientResultsHistoryModal from './Modals/PatientResultsHistoryModal';

function ViewSchedule(props) {
    const [ scheduleMedicalList, setScheduleMedicalList ] = useState([]);
    const [ selectedScheduleDate, setSelectedScheduleDate ] = useState(new Date());
    const [ selectedTimeSchedule, setSelectedTimeSchedule ] = useState(null);
    const [ selectedScheduleMedical, setSelectedScheduleMedical ] = useState(null);
    const [ selectedStatus, setSelectedStatus ] = useState(ALL);
    const [ workHourlyList, setWorkHourlyList ] = useState({});
    const [ searchText, setSearchText ] = useState("");

    const [ isSearchingDate, setIsSearchingDate ] = useState(false);
    const [ isSearchingText, setIsSearchingText ] = useState(false);
    const [ isSetStatus, setIsSetStatus ] = useState(false);
    const [ isShowCircularProgress, setIsShowCircularProgress ] = useState(false);
    const [ isAction, setIsAction ] = useState(false);

    const navigate = useNavigate();
    const mounted = useRef();
    const btnOpenFullScheduleMedicalRef = useRef();

    const [ cookies, setCookie, removeCookie ] = useCookies(["selectedClinic", "loginCookie"]);
    const modalAddEditPatientResult = useDisclosure();
    const openFullScheduleMedical = useDisclosure();
    const patientResultsHistoryModal = useDisclosure();
    const initialRef = useRef(null);
    const t = props.t;
    const MEDICAL_STATUS_LIST = i18n.language === "en" ? MEDICAL_WAITING_STATUS_EN : MEDICAL_WAITING_STATUS;

    useEffect(() => {
        if(!mounted.current) {
            if(isNil(cookies.selectedClinic?.data?.id)) {
                displayConfirmAlert("Bạn vui lòng chọn phòng khám trước khi tiếp tục!", () => {
                    navigate("/");
                });
            } else {
                props.apiLoadASystemSettingByCompanyId({ company_id: cookies?.selectedClinic?.data?.id });
                props.apiLoadListScheduleMedical({
                    company_id: cookies?.selectedClinic?.data?.id,
                    scheduleDate: new Date(),
                    order_by: "time_schedule",
                    order_dir: "asc"
                })
                props.setNavTab(ACTIVE_VIEW_SCHEDULE_TAB);
            }
            setIsAction(cookies.loginCookie?.data?.roles === "admin" || cookies.loginCookie?.data?.roles === "super_admin");
            mounted.current = true;
        }
    });

    useEffect(() => {
        const _WORK_HOURLY_LIST = props.systemSettingDetail?.daily_time_schedules?.work_hourly || WORK_HOURLY_LIST;
        const _workHourlyList = {};
        
        Object.keys(_WORK_HOURLY_LIST).map(key => {
            if(_WORK_HOURLY_LIST[key]) {
                _workHourlyList[key] = true;
            }
        })
        setWorkHourlyList(_workHourlyList);
    }, [props.systemSettingDetail]);
    
    useEffect(() => {
        setIsSearchingDate(false);
        setIsSearchingText(false);
        setIsShowCircularProgress(false);
        const newScheduleMedicalList = orderBy(props.scheduleMedicalList, ["status"], "desc")
        setScheduleMedicalList(newScheduleMedicalList);
    }, [props.scheduleMedicalList]);

    useEffect(() => {
        if(isSetStatus) {
            if(props.actionStatus === SUCCESS_STATUS) {
                toast.success(props.actionMsg, {
                    position: "bottom-right"
                });
                props.clearScheduleMedicalActionStatus();
            } else if(props.actionStatus === FAILED_STATUS) {
                toast.error(`Bạn xác nhận phiếu không thành công!`, {
                    position: "bottom-right"
                });
                props.clearScheduleMedicalActionStatus();
            }
        }
        setIsSetStatus(false);
    }, [props.actionStatus]);

    const handleSearch = async({ isSearchText = false }) => {
        setSelectedTimeSchedule(null);
        setSelectedStatus(ALL);
        setTimeout(() => {
            if(isSearchText) {
                props.apiLoadListScheduleMedical({
                    company_id: cookies?.selectedClinic?.data?.id,
                    searchText,
                    order_by: "time_schedule",
                    order_dir: "asc"
                })
            } else {
                props.apiLoadListScheduleMedical({
                    company_id: cookies?.selectedClinic?.data?.id,
                    scheduleDate: selectedScheduleDate,
                    order_by: "time_schedule",
                    order_dir: "asc"
                })
            }
        }, 500);
    }

    const handleChangeStatus = (newStatus) => {
        setSelectedStatus(newStatus);
        setIsShowCircularProgress(true);
        setTimeout(() => {
            props.apiLoadListScheduleMedical({
                company_id: cookies?.selectedClinic?.data?.id,
                scheduleDate: selectedScheduleDate,
                status: newStatus !== "ALL" ? newStatus : "",
                order_by: "time_schedule",
                order_dir: "asc"
            });
        }, 500);   
    }

    const handleSetStatus = (schedule_medical_id, status) => {
        setIsSetStatus(true);
        setIsShowCircularProgress(true);
        setTimeout(() => {
            props.apiUpdateAScheduleMedical({
                id: schedule_medical_id,
                payload: {
                    "status": status,
                    company_id: cookies?.loginCookie?.data?.company_id,  
                    user_id: cookies?.loginCookie?.data?.id,  
                }
            });
        }, 500);  
    }

    const TOTAL_COUNT = scheduleMedicalList.filter(item => selectedStatus !== "ALL" ? item.status === selectedStatus : true)?.length;

    if(!(cookies.selectedClinic?.data?.id)) {
        return (
            <Flex flexDirection="column">
                <Header />
                <Navbar />
                <NoEventPage text="Bạn vui lòng chọn phòng khám trước khi tiếp tục!"/>
            </Flex>
        )
    }

    return (
        <React.Fragment>
            <Box>
                <Header />
                <Navbar />

                <Flex flexDirection="column" px={2} py={2}>
                    <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} borderRadius={8} bg="#ffffff" boxShadow="md" gap={2}
                        px={2} py={4} justify="space-between"
                    >
                        <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} gap={2}>
                            <InputGroup>
                                <DatePicker dateFormat="dd/MM/yyyy" selected={selectedScheduleDate}
                                    onChange={
                                        (date) => setSelectedScheduleDate(date)
                                    }
                                    showIcon
                                    placeholderText="Ngày đặt hẹn"
                                    className='date-picker'
                                />
                                <InputRightAddon p={0}>
                                    <Button colorScheme='purple'
                                        isLoading={isSearchingDate}
                                        loadingText={t("Lookup")}
                                        onClick={() => {
                                            setIsSearchingDate(true);
                                            handleSearch({ isSearchText: false });
                                        }
                                    }>
                                        {t("Search_By_Date")}
                                    </Button>
                                </InputRightAddon>
                            </InputGroup>
                            <Button minW="160px" ref={btnOpenFullScheduleMedicalRef} colorScheme='teal' onClick={openFullScheduleMedical.onOpen}>
                                {t("View_Time_Frame")}
                            </Button>
                        </Flex>

                        <InputGroup marginRight={4} maxW="500px">
                            <Input placeholder={t("Type_Search_Text")} onChange={(evt) => setSearchText(evt.currentTarget.value)} 
                                onKeyUp={(evt) => {
                                    if(evt.key === "Enter") {
                                        setIsSearchingText(true);
                                        handleSearch({ isSearchText: true });
                                    }
                                }}
                            />
                            <InputRightAddon p={0}>
                                <Button colorScheme='blue' 
                                    isLoading={isSearchingText}
                                    loadingText={t("Searching")}
                                    onClick={() => {
                                        setIsSearchingText(true);
                                        handleSearch({ isSearchText: true });
                                    }
                                }>
                                    {t("Search")}
                                </Button>
                            </InputRightAddon>
                        </InputGroup>
                    </Flex>

                    <Box borderRadius={8} bg="#ffffff" px={2} py={2} marginTop={2}>
                        <Drawer
                            isOpen={openFullScheduleMedical.isOpen}
                            placement="left"
                            onClose={openFullScheduleMedical.onClose}
                            finalFocusRef={btnOpenFullScheduleMedicalRef}
                        >
                            <DrawerOverlay />
                            <DrawerContent>
                                <DrawerCloseButton />
                                <DrawerHeader>
                                    <Box textAlign="center">
                                        <Text textTransform="uppercase">{t("Medical_Schedule")}</Text>
                                        <Text fontWeight="700">
                                            {selectedScheduleDate && <FormattedDate value={selectedScheduleDate} />}
                                        </Text>
                                    </Box>
                                </DrawerHeader>
                                <Divider />
                                <DrawerBody>
                                    <Flex minW="10%" flexDirection="column" px={2}>
                                        {
                                            Object.keys(workHourlyList).map((key, idx) => {
                                                let count = scheduleMedicalList.filter(item => item.time_schedule === key).length;

                                                return (
                                                    <HStack key={key} mb={1} px={1} justify="space-between"
                                                        _hover={{ cursor: (count > 0 ? 'pointer' : '') }} 
                                                        onClick={() => count > 0 ? setSelectedTimeSchedule(key) : null} 
                                                    >
                                                        <Heading color="green.700" size="sm">{key}</Heading>
                                                        <Text fontWeight="700" color={count > 0 ? "gray.700" : "gray.300"}>
                                                            {count} {t("Turn")}
                                                        </Text>
                                                    </HStack>
                                                )
                                            })
                                        }

                                        <HStack mt={2} px={1} color="orange.500" justify="space-between"
                                            _hover={{ cursor: (TOTAL_COUNT > 0 ? 'pointer' : '') }}
                                            onClick={() => TOTAL_COUNT > 0 ? setSelectedTimeSchedule(null) : null} 
                                        >
                                            <Heading size="sm">{t("Total")}</Heading>
                                            <Text fontWeight="700">
                                                {TOTAL_COUNT} {t("Turn")}
                                            </Text>
                                        </HStack>
                                    </Flex>
                                </DrawerBody>
                            </DrawerContent>
                        </Drawer>  

                        <Flex flexDirection={{base: "column", md: "row", lg: "row"}} w="100%" 
                            alignContent="space-between" justifyContent="space-between" px={4}
                        >
                            <Text fontSize="16px" fontWeight="700" color="#007F4E">
                                {t("Medical_Schedule_List")} <Badge variant='solid' colorScheme='blue' fontSize="14px">{selectedTimeSchedule}</Badge>
                            </Text>

                            <Select w="200px" value={selectedStatus} borderColor="#00b0ff"
                                onChange={(current) => handleChangeStatus(current.target.value)} 
                            >
                                <option value="ALL">{t("All")}</option>
                                {
                                    Object.keys(MEDICAL_STATUS_LIST).map(key => (
                                        <React.Fragment key={key}>
                                            <option value={key}>{MEDICAL_STATUS_LIST[key]}</option>
                                        </React.Fragment>
                                    ))
                                }
                            </Select>
                        </Flex>

                        <TableContainer width="100%" px="20px" py="5px">
                            <Table variant="simple" size="sm">
                                <Thead>
                                    <Tr bg="#EAF0F0" textTransform="uppercase">
                                        <Th>{t("Index")}</Th>
                                        <Th>{t("Schedule_Date")}</Th>
                                        <Th>{t("Register_Person")}</Th>
                                        <Th>{t("Ticket_Code")}</Th>
                                        <Th>{t("Department_Specialist")} - {t("Doctor")}</Th>
                                        <Th>{t("Schedule_Reason")}</Th>
                                        <Th>{t("Service")}</Th>
                                        <Th>{t("Register_Created_At")}</Th>
                                        {
                                            (cookies?.loginCookie?.data?.company_id == cookies.selectedClinic?.data?.id) &&
                                            <React.Fragment>
                                                <Th isNumeric></Th>
                                                <Th isNumeric></Th>
                                            </React.Fragment>
                                        }
                                    </Tr>
                                </Thead>
                                <Tbody>
                                    {
                                        scheduleMedicalList.filter(item => selectedTimeSchedule ? item.time_schedule === selectedTimeSchedule : true)
                                            .map((item, idx) => 
                                        {
                                            let badgeStatusComponent = null;

                                            if(item.status === PROCESSING_STATUS || !item.status) {
                                                badgeStatusComponent = <Badge variant="solid" p={1}>{t("Processing")}</Badge>
                                            } else if(item.status === FINISHED_STATUS) {
                                                badgeStatusComponent = <Badge variant="solid" colorScheme='green' p={1}>{t("Finished")}</Badge>
                                            } else if(item.status === CANCEL_STATUS) {
                                                badgeStatusComponent = <Badge variant="solid" colorScheme='red' p={1}>{t("Cancel")}</Badge>
                                            } else if(item.status === PENDING_STATUS) {
                                                badgeStatusComponent = <Badge variant="solid" colorScheme='orange' p={1}>{t("Pending")}</Badge>
                                            }

                                            return (
                                                <Tr key={item.id} fontWeight="600">
                                                    <Td>{idx + 1}</Td>
                                                    <Td>
                                                        <VStack align="flex-start">
                                                            <Badge colorScheme="orange">{item.time_schedule}</Badge>
                                                            { item.day_schedule && <Text><FormattedDate value={item.day_schedule} /></Text> }
                                                        </VStack>
                                                    </Td>
                                                    <Td>
                                                        <VStack align="flex-start">
                                                            <Badge p={1} colorScheme="green">{item?.patientDetail?.name}</Badge>
                                                            <Text>{`SĐT: ${item?.patientDetail?.phone}`}</Text>
                                                        </VStack>
                                                    </Td>
                                                    <Td>
                                                        <VStack align="flex-start">
                                                            <Text fontSize="16px" color="orange.500">{item.schedule_number}</Text>
                                                            {badgeStatusComponent}
                                                        </VStack>
                                                    </Td>
                                                    <Td>
                                                        <VStack align="flex-start">
                                                            <Text>{`PK: ${item?.departmentDetail?.name} (${item?.departmentDetail?.specialist})`}</Text>
                                                            <Text>{`BS: ${item?.doctorDetail?.name}`}</Text>
                                                        </VStack>
                                                    </Td>
                                                    <Td>{item.description}</Td>
                                                    <Td>
                                                        { item.service_prices && Object.values(item.service_prices).map(doc => doc.name).join(", ") }
                                                    </Td>
                                                    <Td>
                                                        <Text>
                                                            <FormattedDate value={item.created_at} /> <FormattedTime value={item.created_at} />
                                                        </Text>
                                                    </Td>
                                                    {
                                                        (cookies?.loginCookie?.data?.company_id == cookies.selectedClinic?.data?.id) &&
                                                        <Td>
                                                            <VStack align="flex-start">
                                                                <Button size="sm" colorScheme="green" 
                                                                    isDisabled={(item.status === FINISHED_STATUS) || !isAction}
                                                                    onClick={() => {
                                                                            displayConfirmChoiceAlert(`Bạn có xác nhận "${MEDICAL_STATUS_LIST[FINISHED_STATUS]}" phiếu này không?`, () => {
                                                                                handleSetStatus(item.id, FINISHED_STATUS);
                                                                            });
                                                                        }
                                                                    }
                                                                >
                                                                    <Icon boxSize={4} as={MdThumbUp} marginRight="8px"/>   
                                                                    <Text fontWeight="400" textTransform="uppercase">{t("Finished")}</Text>
                                                                </Button>
                                                                
                                                                <Button size="sm" colorScheme="orange" 
                                                                    isDisabled={(item.status === PENDING_STATUS) || !isAction} 
                                                                    onClick={() => {
                                                                        displayConfirmChoiceAlert(`Bạn có xác nhận "${MEDICAL_STATUS_LIST[PENDING_STATUS]}" phiếu này không?`, () => {
                                                                            handleSetStatus(item.id, PENDING_STATUS);
                                                                        });
                                                                    }
                                                                }
                                                                >
                                                                    <Icon boxSize={4} as={MdPending} marginRight="8px"/>   
                                                                    <Text fontWeight="400" textTransform="uppercase">{t("Pending")}</Text>
                                                                </Button>

                                                                <Button size="sm" colorScheme="red" 
                                                                    isDisabled={(item.status === CANCEL_STATUS) || !isAction} 
                                                                    onClick={() => {
                                                                        displayConfirmChoiceAlert(`Bạn có xác nhận "${MEDICAL_STATUS_LIST[CANCEL_STATUS]}" phiếu này không?`, () => {
                                                                            handleSetStatus(item.id, CANCEL_STATUS);
                                                                        });
                                                                    }
                                                                }
                                                                >
                                                                    <Icon boxSize={4} as={MdCancel} marginRight="8px"/>   
                                                                    <Text fontWeight="400" textTransform="uppercase">{t("Cancel")}</Text>
                                                                </Button>
                                                            </VStack>
                                                        </Td>
                                                    }
                                                    {
                                                        (cookies?.loginCookie?.data?.company_id == cookies.selectedClinic?.data?.id) &&
                                                        <Td>
                                                            <VStack alignItems="flex-start">
                                                                <Button colorScheme='gray' size="sm" mr={3} isDisabled={!isAction}
                                                                    onClick={
                                                                        () => {
                                                                            setSelectedScheduleMedical(item);
                                                                            patientResultsHistoryModal.onOpen();
                                                                        }
                                                                    }
                                                                >
                                                                    <Icon boxSize={4} as={MdHistory} marginRight="8px"/> 
                                                                    <Text fontSize="14px">
                                                                        {t("View_Patient_History")}
                                                                    </Text>
                                                                </Button>

                                                                <Button size="sm" colorScheme="blue" mr={3} isDisabled={!isAction}  
                                                                    onClick={
                                                                        () => {
                                                                            setSelectedScheduleMedical(item);
                                                                            modalAddEditPatientResult.onOpen();
                                                                        }
                                                                    }>
                                                                    <Icon boxSize={4} as={MdNoteAlt} marginRight="8px"/> 
                                                                    <Text fontSize="14px">{t("Type_Patient_Result")}</Text>
                                                                </Button>
                                                            </VStack>
                                                        </Td>
                                                    }
                                                </Tr>
                                            )
                                        })
                                    }
                                </Tbody>
                            </Table>
                        </TableContainer>

                        {
                            !(scheduleMedicalList && scheduleMedicalList.length > 0) && <NoDataPage text="Hiện tại chưa có dữ liệu về lịch đặt khám"/>
                        }
                    </Box>
                </Flex>
            </Box>
            {
                patientResultsHistoryModal.isOpen &&
                <PatientResultsHistoryModal 
                    initialRef={initialRef} isOpen={patientResultsHistoryModal.isOpen} onClose={patientResultsHistoryModal.onClose}
                    patientDetail={selectedScheduleMedical?.patientDetail} isAction={isAction}
                />
            }
            {
                modalAddEditPatientResult.isOpen &&
                <AddEditPatientResultModal 
                    initialRef={initialRef} isOpen={modalAddEditPatientResult.isOpen} onClose={modalAddEditPatientResult.onClose}
                    patientDetail={selectedScheduleMedical?.patientDetail}
                    scheduleMedicalId={selectedScheduleMedical?.id}
                    onFinished={() => handleSetStatus(selectedScheduleMedical?.id, FINISHED_STATUS)}
                />
            }
            {
                isShowCircularProgress &&
                <Center>
                    <CircularProgress position="fixed" top="20vh" isIndeterminate size="200px" zIndex={9999}>
                        <CircularProgressLabel fontSize="24px" fontWeight="700" color="#2196f3">{t("Loading")}</CircularProgressLabel>
                    </CircularProgress>
                </Center>
            }
            <ToastContainer />
        </React.Fragment>
    )
}

const mapStateToProps = (state) => {
    const currentNavTab =           getCurrentNavTab(state);
    const systemSettingDetail   =   getASystemSetting(state);
    const scheduleMedicalList   =   getScheduleMedicalList(state);
    const actionStatus          =   getScheduleMedicalActionStatus(state);
    const actionMsg             =   getScheduleMedicalActionMsg(state);

    return { currentNavTab, systemSettingDetail, scheduleMedicalList, actionStatus, actionMsg };
}

const mapDispatchToProps = (dispatch) => ({
    setNavTab:                              payload => dispatch(setNavTab(payload)),
    apiLoadASystemSettingByCompanyId:       payload => dispatch(apiLoadASystemSettingByCompanyId(payload)),
    apiLoadListScheduleMedical:             payload => dispatch(apiLoadListScheduleMedical(payload)),
    apiUpdateAScheduleMedical:              payload => dispatch(apiUpdateAScheduleMedical(payload)),

    clearScheduleMedicalActionStatus:       payload => dispatch(clearScheduleMedicalActionStatus(payload)),
})

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces()(ViewSchedule));